import React from 'react';
import { PlusIcon } from 'lucide-react';
import type { Faq } from '../types/site';
interface FaqItemProps {
  faq: Faq;
  id: string;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  faq,
  id,
  open,
  onToggle
}: FaqItemProps) {
  const buttonId = `${id}-button`;
  const panelId = `${id}-panel`;
  return <div className="border-b border-line" data-id="element-60" data-mp="1qzjv4eg4c7id">
      <h3 data-id="element-61" data-mp="1d13he3ju9gqq">
        <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={onToggle} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left text-[18px] font-semibold text-ink transition-colors duration-150 ease-out hover:text-brand-deep md:text-[20px]" data-id="element-62" data-mp="1d1bsbpweibza">
          {faq.question}
          <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${open ? 'rotate-45 text-brand' : ''}`} data-id="element-63" data-mp="2xgf6jixnbpln" />
        </button>
      </h3>
      <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!open} className="overflow-hidden" data-id="element-64" data-mp="101kyu8uu7ecz">
        <p className="max-w-[44rem] pb-7 pr-10 text-[16px] leading-relaxed text-steel md:text-[17px]" data-id="element-65" data-mp="v1gsvcrk2210">{faq.answer}</p>
      </div>
    </div>;
}